import React, { FC } from 'react'
import './tab-group.css'

// UTILITIES
import { flatten } from '@utils/string-helper'


interface Props extends React.HTMLAttributes<HTMLDivElement> {
    tabs: { name: string, icon?: React.ReactNode }[]
    activeTab: string
    light?: boolean
    onTabChange?: (id: string) => void
}

const TabGroup: FC<Props> = (props) => {
    const { className: classProps, tabs, activeTab, light, onTabChange, ...divProps } = props
    const className = flatten('tab-group', 'flex flex-row items-center', light ? 'light' : '', classProps)

    return (
        <div className={className} {...divProps}>
            {tabs.map(({ name, icon }, index) => (
                <p key={`${name}-${index}`} className={flatten('select-none tab-group-tab flex flex-row items-center justify-center gap-2', name === activeTab ? 'active' : undefined)} onClick={() => { onTabChange?.call(undefined, name) }}>
                    {icon}
                    {name}
                </p>
            ))}
        </div>
    )
}

export default TabGroup